<template>
    <div class="flex lg:flex-col flex-row lg:mr-20" v-show="!isEmpty">

        <div class="">

            <div class="pb-4">

                <div class="flex lg:flex-col">

                    <div class="">
                        <periodicity></periodicity>
                    </div>

                </div>

                <div class="flex lg:flex-col flex-row">

                    <h2 class="hidden lg:block mt-8 mb-2 uppercase font-semibold text-base text-grey-darker">
                        ad hoc calculator
                        <info-helper>
                            modify the data by applying one or more modifiers
                        </info-helper>
                    </h2>

                    <div class="py-2 lg:py-4 flex-row flex-no-wrap lg:flex-wrap flex lg:items-stretch text-center">
                        <compute-index></compute-index>

                        <compute-rate-of-change></compute-rate-of-change>

                        <compute-aggregation></compute-aggregation>

                        <compute-interpolation></compute-interpolation>

                        <compute-forecast></compute-forecast>

                        <compute-limit-data></compute-limit-data>

                        <compute-moving-average></compute-moving-average>

                        <image-button
                                @click.native="update('clean', selected)"
                                img="/images/svg/ATS3bdSeriesicon_remove.svg"
                        >
                            reset calculations
                        </image-button>
                    </div>

                    <div v-show="periodicity === 'A'" v-if="false">

                        <div class="lg:mt-6">

                        </div>

                        <h2 class="hidden lg:block mt-8 uppercase font-semibold text-base text-grey-dark">
                            pattern search
                            <info-helper>
                                <p>Analyse Time Series (available for annual series only)</p>

                                <p>
                                    Each time series can be correlated by Pearson's coefficient with
                                    millions time series to track for an alternative source, e.g. to
                                </p>

                                <ul>
                                    <li>identify the most up-to-date series within other statistical sources</li>
                                    <li>check for a longer data history</li>
                                    <li>prove for alternative dimensions</li>
                                    <li>check given time series for completeness and correctness</li>
                                    <li>identify poorly documented or unknown time series</li>
                                    <li>explore and discover new exciting economic correlations</li>
                                </ul>
                            </info-helper>
                        </h2>

                        <regression class="lg:p-4 py-2"></regression>

                    </div>

                </div>


                <div class="flex flex-col">


                </div>

            </div>

        </div>

    </div>

</template>

<script>
    import ImageButton from "./ImageButton";
    import Modal from "./Modal";
    import InfoHelper from "./InfoHelper";
    import ModalBottom from "./ModalBottom";
    import ComputeIndex from "./Compute/ComputeIndex";
    import ComputeRateOfChange from "./Compute/ComputeRateOfChange";
    import ComputeInterpolation from "./Compute/ComputeInterpolation";
    import ComputeForecast from "./Compute/ComputeForecast";
    import ComputeLimitData from "./Compute/ComputeLimitData";
    import ComputeMovingAverage from "./Compute/ComputeMovingAverage";
    import ComputeAggregation from "./Compute/ComputeAggregation";

    export default {

        components: {
            ComputeAggregation,
            ComputeMovingAverage,
            ComputeLimitData,
            ComputeForecast,
            ComputeInterpolation,
            ComputeRateOfChange,
            ComputeIndex,
            ModalBottom,
            InfoHelper,
            ImageButton,
            Modal
        },

        computed: {
            isEmpty() {
                return this.$store.getters.isEmpty;
            },
            periodicity() {
                return this.$store.state.periodicity;
            },
            selected() {
                return this.$store.state.rawData.data[this.$store.state.periodicity].data.map(function (item, index) {
                    return index;
                });
            },
        },

        methods: {
            update: function (action, ids, parameters) {
                this.$store.dispatch('update', {action: action, ids: ids, parameters: parameters});
            },
        },
    }
</script>
